import { useCallback, useMemo, useState } from 'react';

export function useLocalStorage<T>(key: string, initialValue?: T) {
  const [state, setState] = useState<T>(
    localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key) as string).value : (initialValue ?? null)
  );

  const setLocalStorage = useCallback(
    (value: T) => {
      localStorage.setItem(key, JSON.stringify({ value }));
      setState(value);
    },
    [key, setState]
  );

  return useMemo(() => [state, setLocalStorage] as const, [state, setLocalStorage]);
}
